<template>
  <div>
    <notice-bar v-if="notice">{{ notice }}</notice-bar>
    <base-form
      ref="form"
      :items="data"
      label-width="4em"
      submitText="下一步"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { NoticeBar } from "vant";
import BaseForm from "@/components/BaseForm";
import { checkPhone } from "@/http/account";
import { mixinForward } from "@/mixins/mixinForward";

const CHECK_TYPE = 4;

export default {
  name: "Verifier",
  components: { NoticeBar, BaseForm },
  mixins: [mixinForward],
  data() {
    return {
      data: [
        { name: "boundiconPhone" },
        { name: "telCode", type: CHECK_TYPE, moduleType: true }
      ]
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    notice() {
      return this.$route.query.desc || "";
    }
  },
  mounted() {
    if (this.userInfo.security_telphone) {
      this.$set(
        this.data,
        0,
        Object.assign({}, this.data[0], {
          value: this.userInfo.security_telphone,
          disabled: true
        })
      );
    } else {
      // 未绑定手机需要先绑定手机
      this.$router.replace({
        path: this._anchor.bindPhone.path,
        query: {
          isModifyPhone: false
        }
      });
    }
  },
  methods: {
    /**
     * @description 安全项认证
     * @param {object} formdata  - 表单对象值
     */
    onSubmit(formdata) {
      checkPhone({
        type: CHECK_TYPE,
        code: formdata.telCode
      })
        .then(res => {
          if (res.rcode === 0) {
            // 验证完成后跳转目标地址
            if (this.$route.query) {
              if (this.$route.query.redirect) {
                if (this.$route.query.redirect.indexOf("http") === 0) {
                  location.href = this.$route.query.redirect;
                } else {
                  this.$router.replace(this.$route.query.redirect);
                }
              } else if (this.forward) {
                location.href = this.forward;
              } else {
                this.$router.replace({ path: this._anchor.index.path });
              }
            }
          }
        })
        .finally(() => {
          this.$refs.form.disabled = false;
        });
    }
  }
};
</script>
